export default {
  group: {
    id: 0,
    name: null,
    surveyTypeID: null,
    locationID: null,
    k12Education: null
  },
  groups: []
}



// WEBPACK FOOTER //
// ./src/store/modules/group/state.js